import * as React from 'react'
import type { SVGProps } from 'react'
const SvgBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.2826 6.20002H1.21822M13.75 9.5C11.4069 9.5 7.75 9.5 7.75 9.5M20.3504 6.76659V18.2C20.3504 19.5255 19.2759 20.6 17.9504 20.6H3.55039C2.22491 20.6 1.15039 19.5255 1.15039 18.2V6.76659C1.15039 6.394 1.23714 6.02653 1.40377 5.69327L3.05288 2.39504C3.35779 1.78523 3.98106 1.40002 4.66285 1.40002H16.8379C17.5197 1.40002 18.143 1.78523 18.4479 2.39504L20.097 5.69328C20.2636 6.02653 20.3504 6.394 20.3504 6.76659Z"
      stroke="#2E2F40"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgBox
